/* GENERATED by scripts/gen-data.mjs — chapters that state a capability up front (from s5.js).
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. Edit the content in the artifact and re-run
 * npm run extract, do not hand-edit here. */

export const GOAL_NODES: string[] = [
  "what-ai-is",
  "model-families",
  "grounding",
  "memory",
  "event-bus",
  "service-split",
  "frontend-composition",
  "tooling",
  "guardrails",
  "evaluate",
  "production",
  "deploy",
  "monitor",
  "x-curriculum",
  "x-softmax",
  "x-delivery",
  "x-contracts",
  "x-threats",
  "x-drift",
  "x-cost",
  "x-agents",
  "x-structured",
  "x-compliance",
  "x-latency",
  "x-nats",
  "x-federation",
  "bonus-pipeline"
];
